import { render, staticRenderFns } from "./UserElement.vue?vue&type=template&id=3f837d33&scoped=true"
import script from "./UserElement.vue?vue&type=script&lang=js"
export * from "./UserElement.vue?vue&type=script&lang=js"
import style0 from "./UserElement.vue?vue&type=style&index=0&id=3f837d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f837d33",
  null
  
)

export default component.exports